var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"form-app"},on:{"click":function($event){if($event.target !== $event.currentTarget){ return null; }_vm.select(null)}}},[(_vm.type === 'rent')?_c('rent',{attrs:{"strtime":_vm.data.time},on:{"select":_vm.select}}):_vm._e(),_vm._v(" "),(_vm.type === 'tour')?_c('tours',{on:{"select":_vm.select}}):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-75a2247c","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/FormApp.vue
// module id = null
// module chunks = 